{
  assertFails: (fn, ...args) -> do
    let message = first(args);
    assert(isFunction(fn), "First argument must be a function");
    if not(isNull(message)) then
      assert(isString(message), "Second argument must be a string")
    else
      null
    end;
    let failedSentinel = @assertion.failed;
    let errorHandler =
      handler
        @dvala.error(err) -> [failedSentinel, err]
      end;
    let result = errorHandler(-> fn());
    if isArray(result) && first(result) == failedSentinel then
      null
    else
      assert(false, message ?? "Expected function to fail")
    end;
  end,
  assertFailsWith: (fn, expectedError, ...args) -> do
    let message = first(args);
    assert(isFunction(fn), "First argument must be a function");
    assert(isString(expectedError), "Second argument must be a string");
    if not(isNull(message)) then
      assert(isString(message), "Third argument must be a string")
    else
      null
    end;
    let failedSentinel = @assertion.failed;
    let errorHandler =
      handler
        @dvala.error(err) -> [failedSentinel, err]
      end;
    let result = errorHandler(-> fn());
    if isArray(result) && first(result) == failedSentinel then
      do
        let actualError = second(result).message;
        if actualError == expectedError then
          null
        else
          assert(
            false,
            message ??
              "Expected function to fail with \"" ++ expectedError ++
                "\" but got \"" ++
                actualError ++
                "\""
          )
        end;
      end
    else
      assert(
        false,
        message ?? "Expected function to fail with \"" ++ expectedError ++ "\""
      )
    end;
  end,
  assertSucceeds: (fn, ...args) -> do
    let message = first(args);
    assert(isFunction(fn), "First argument must be a function");
    if not(isNull(message)) then
      assert(isString(message), "Second argument must be a string")
    else
      null
    end;
    let failedSentinel = @assertion.failed;
    let errorHandler =
      handler
        @dvala.error(err) -> failedSentinel
      end;
    let result = errorHandler(-> fn());
    if isEffect(result) && result == failedSentinel then
      assert(false, message ?? "Expected function to succeed")
    else
      null
    end;
  end,
};
